import React from 'react';
import { CancelOrderAction } from '../../components/ActionButtons';
import Modal from '../../components/Modal';
import { cancelGearReq } from '../../util/apiUtils';

/**
 * A button and logic to cancel a single test (GearReq) on a PITL order.
 */
const CancelTest = ({ gearOrder, gearReq, setDisplayCancelModal }) => {
	return (
		<CancelOrderAction
			gearOrder={gearOrder}
			key="cancel"
			onClick={() => {
				setDisplayCancelModal(true);
			}}
			button={
				<button className={`btn btn-edit btn-danger`} title="Cancel Test">
					Cancel Test
				</button>
			}
		/>
	);
};

/**
 * A modal to confirm test cancellation.
 */
export const CancelTestModal = ({
	requisitionName,
	gearOrderId,
	gearReqId,
	dateOfBirth,
	setDisplayCancelModal,
	setGearOrder,
	setActionResponse,
	setLoading
}) => {
	const onCancelTest = () => {
		setLoading(true);
		cancelGearReq(gearOrderId, gearReqId, dateOfBirth)
			.then((updatedOrder) => {
				setGearOrder(updatedOrder);
			})
			.catch((e) => {
				console.error('Error canceling test', e);
				setActionResponse({
					status: 'danger',
					message: 'An unexpected error occurred. Please try again.'
				});
			})
			.finally(() => {
				setDisplayCancelModal(false);
				setLoading(false);
			});
	};

	return (
		<Modal
			title="Confirm Cancellation"
			confirmAction="Yes, Cancel My Test"
			cancelAction="No, Keep My Test"
			onSave={onCancelTest}
			onCancel={() => {
				setDisplayCancelModal(false);
			}}
			modalHidden={() => setDisplayCancelModal(false)}
		>
			<div>
				<div style={{ zIndex: '10' }}>
					<span>
						Are you sure you would like to cancel <b>{requisitionName}</b>?{' '}
					</span>
					<span>
						If so, please refer to our{' '}
						<a
							href="https://connect.gdx.net/refund-policy"
							target="_blank"
							rel="noopener noreferrer"
							title="Refund Policy"
						>
							refund policy
						</a>{' '}
						for additional information regarding your refund.
					</span>
				</div>
			</div>
		</Modal>
	);
};

// Allow cancel (GearReq.Deleted) if the pack has not been canceled, accessioned, or recollected
export const canCancelTest = ({ gearOrder, gearReq }) => {
	return (
		!gearReq.canceled &&
		!gearReq.accessionDetails &&
		!gearOrder.pitlRecollectionOrderSummary?.gearReqRecollectionMap?.[gearReq.id]
	);
};

export default CancelTest;
